import { render, staticRenderFns } from "./ChallengeInfo.vue?vue&type=template&id=3f5019a7&"
import script from "./ChallengeInfo.vue?vue&type=script&lang=js&"
export * from "./ChallengeInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports